import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import fondo from '../assets/viaje.webp';
import Swal from "sweetalert2";
import '../styles/disenocalculadorasbase.css';

export default function CalculadoraConocerMundo() {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [edad, setEdad] = useState("");
  const [ingreso, setIngreso] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [crecimiento] = useState("9");

  const handleSubmit = () => {
    if (!nombre || !edad || !ingreso || !tiempo) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Por favor, completa todos los campos.",
      });
      return;
    }

    if (isNaN(edad) || edad <= 0 || edad > 99) {
      Swal.fire({
        icon: "error",
        title: "Edad inválida",
        text: "Por favor, ingresa una edad válida entre 1 y 99.",
      });
      return;
    }

    if (isNaN(ingreso) || ingreso <= 0) {
      Swal.fire({
        icon: "error",
        title: "Ingreso inválido",
        text: "El ingreso debe ser un número mayor que cero.",
      });
      return;
    }

    navigate("/DisplayCalculo", {
      state: { nombre, edad, ingreso, tiempo, crecimiento }
    });
  };

  return (
    <>
      <button
        onClick={() => navigate('/')}
        className="calculadora-back"
      >
        ← Regresar al Menú
      </button>
      <div className="calculadora-container">
        <div 
          className="calculadora-left"
          style={{ backgroundImage: `url(${fondo})` }}
        >
          <div className="calculadora-overlay">
            <h1>¿Te gustaría conocer el mundo?</h1>
            <p>
              Llena el formulario para calcular cuánto necesitas ahorrar y alcanzar tus metas de viaje.
            </p>
          </div>
        </div>

        <div className="calculadora-form">
          <h2>Simulador para Viajar</h2>

          <label>Nombre:</label>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />

          <label>Edad:</label>
          <input
            type="number"
            value={edad}
            onChange={(e) => {
              const valor = e.target.value;
              if (valor === "" || (Number(valor) >= 1 && Number(valor) <= 99)) {
                setEdad(valor);
              }
            }}
            min="1"
            max="99"
          />

          <label>Ingreso al fondo (mensualmente):</label>
          <input
            type="number"
            value={ingreso}
            onChange={(e) => setIngreso(e.target.value)}
            min="1"
          />

          <label>Tiempo (en años):</label>
          <select
            value={tiempo}
            onChange={(e) => setTiempo(e.target.value)}
          >
            <option value="">Selecciona un tiempo</option>
            {[...Array(20)].map((_, i) => (
              <option key={i + 1} value={i + 1}>{i + 1}</option>
            ))}
          </select>

          <button onClick={handleSubmit} className="calculadora-btn">Crear Cálculo</button>

          <p
            onClick={() => navigate("/pantallaCIT")}
            className="calculadora-link"
          >
            ¿Te gustaría planearlo mejor? Agenda tu cita aquí!
          </p>
        </div>
      </div>
    </>
  );
}

